export default function BrushIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g id='brush'>
        <mask
          id='mask0_381_8344'
          style={{ maskType: 'alpha' }}
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='24'
          height='24'
        >
          <rect id='Bounding box' width='24' height='24' fill='#D9D9D9' />
        </mask>
        <g mask='url(#mask0_381_8344)'>
          <path
            id='brush_2'
            d='M6 20.9958C5.25 20.9958 4.50833 20.8125 3.775 20.4458C3.04167 20.0791 2.45 19.5958 2 18.9958C2.43333 18.9958 2.875 18.825 3.325 18.4833C3.775 18.1416 4 17.6458 4 16.9958C4 16.1625 4.29167 15.4541 4.875 14.8708C5.45833 14.2875 6.16667 13.9958 7 13.9958C7.83333 13.9958 8.54167 14.2875 9.125 14.8708C9.70833 15.4541 10 16.1625 10 16.9958C10 18.0958 9.60833 19.0375 8.825 19.8208C8.04167 20.6041 7.1 20.9958 6 20.9958ZM6 18.9958C6.55 18.9958 7.02083 18.8 7.4125 18.4083C7.80417 18.0166 8 17.5458 8 16.9958C8 16.7125 7.90417 16.475 7.7125 16.2833C7.52083 16.0916 7.28333 15.9958 7 15.9958C6.71667 15.9958 6.47917 16.0916 6.2875 16.2833C6.09583 16.475 6 16.7125 6 16.9958C6 17.3791 5.95417 17.7291 5.8625 18.0458C5.77083 18.3625 5.65 18.6625 5.5 18.9458C5.58333 18.9791 5.66667 18.9958 5.75 18.9958H6ZM11.75 14.9958L9 12.2458L17.95 3.29581C18.1333 3.11248 18.3625 3.01665 18.6375 3.00831C18.9125 2.99998 19.15 3.09581 19.35 3.29581L20.7 4.64581C20.9 4.84581 21 5.07915 21 5.34581C21 5.61248 20.9 5.84581 20.7 6.04581L11.75 14.9958Z'
            fill='#1C1B1F'
          />
        </g>
      </g>
    </svg>
  );
}
